import React from "react";
import { Row, Col } from "react-bootstrap";

const UserDispecer = ({ user }) => {
  return (
    <Row className="mb-2">
      <Col>{`${user.firstName} ${user.lastName}`}</Col>
      <Col>{user.userName}</Col>
      <Col></Col>
    </Row>
  );
};

export default UserDispecer;
